var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
import { OnInit, ChangeDetectorRef, EventEmitter, TemplateRef, ElementRef } from '@angular/core';
import { GalleryColumns } from 'src/app/gallery/models/gallery-list-columns.enum';
var GalleryListComponent = /** @class */ (function () {
    function GalleryListComponent(changeDetectorRef) {
        this.changeDetectorRef = changeDetectorRef;
        this.selectLabel = 'Select';
        this._columns = [
            GalleryColumns.Model,
            GalleryColumns.Tags,
            GalleryColumns.CreatedBy,
            GalleryColumns.UpdatedBy,
            GalleryColumns.Actions
        ];
        this.showActions = false;
        this.checkable = false;
        this.checkedResults = [];
        this.checkedChange = new EventEmitter();
        this.selectBookmark = new EventEmitter();
    }
    Object.defineProperty(GalleryListComponent.prototype, "columns", {
        get: function () {
            return this._columns;
        },
        set: function (value) {
            this._columns = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GalleryListComponent.prototype, "results", {
        get: function () {
            return this._results;
        },
        set: function (value) {
            this._results = value;
            this.changeDetectorRef.markForCheck();
        },
        enumerable: true,
        configurable: true
    });
    GalleryListComponent.prototype.ngOnInit = function () {
    };
    GalleryListComponent.prototype.handleSelect = function (result) {
        this.selectBookmark.emit(result);
    };
    GalleryListComponent.prototype.handleCheckedChange = function (event) {
        var ids = (event.checked) ? __spread(this.checkedResults, [event.source.value]) : this.checkedResults.filter(function (id) { return id !== event.source.value; });
        this.checkedChange.emit(ids);
    };
    GalleryListComponent.prototype.isChecked = function (id) {
        return this.checkedResults.indexOf(id) >= 0;
    };
    return GalleryListComponent;
}());
export { GalleryListComponent };
